import { get } from 'config/api/config';

const QUOTES_ENDPOINT = '/viewer/quotes';

export const getQuotes = async () => {
  const response = await get<any>(QUOTES_ENDPOINT);
  return response?.data;
};
